<template>
    <main class="container">
        <h1>Setting up Power</h1>

        <section>
            <h2>
                Requirements
            </h2>
            <ul>
                <li>5v Micro USB 3 Amp Power Supply</li>
            </ul>
        </section>

        <section>
            <h2>Instructions</h2>

            <ol>
                <li>Connect power adapter to power socket, then plug the USB cable into the GoMonitor
                </li>
                <li>When the device is on you will notice an internal red LED light.
                    <div class="red_status_dot" style="
                            background-color: #ff7575;
                            border-radius: 50px;
                            width: 20px;

                            height: 20px;
                            display: inline-block">
                    </div>
                </li>
            </ol>
        </section>

        <div class="row">
            <div class="col-2"><button class="btn btn-dark btn-lg" @click="back">
                    <i class="fas fa-arrow-left"></i>
                </button>
            </div>
            <div class="col-10">

                <router-link class="btn btn-dark btn-lg" to="/setup/2">
                    It's On
                </router-link>
            </div>
        </div>

    </main>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

function back() {
    router.go(-1);
}

</script>
